<template>
  <div class="modal-background">
    <div class="l-login-popin animated go fadeInRight in">
      <div class="l-login-popin-container float-center">
        <div class="text--right">
          <div class="l-login-popin__close-button" @click="closeLogin">
            <button
              class="c-button c-button--rounded l-login-popin__close-toggler c-button--close"
              type="button"
            >
              <i class="iconfont">&#xe615;</i>
            </button>
          </div>
        </div>
        <div class="l-login-popin__heading">
          <h2>您的购物袋</h2>
        </div>
        <div class="l-login-popin__item-separator">
          <div class="m-cart__body" v-if="cartInfo && cartInfo.goods_list && cartInfo.goods_list.goods && cartInfo.goods_list.goods.length">
            <VueScroll :ops="vsOpts">
              <div class="cart cart-page">
                <template v-for="(outerItem, outerIndex) in cartInfo.goods_list.goods">
                  <template v-for="(innerItem, innerIndex) in outerItem.main">
                      <CartItemMini :base="innerItem"  @remove="onItemRemove"  :key="`${outerIndex}-${innerIndex}_${innerItem.sku}`" />
                  </template>
                </template>
              </div>
              <div v-if="cartInfo.goods_list.goods.length == 1" class="miniPrice">
                <div class="price_box">
                  <div class="price_name">总计:</div>
                  <div class="price_num">￥{{totalPrice}}</div>
                </div>
                <div class="to_cart" @click="toCart">查看购物袋</div>
              </div>
            </VueScroll>
          </div>
            <!-- 购物车为空 -->
          <div v-else class="cart_none">
              <div class="cart_none_msg">购物袋为空</div>
              <div class="go_home" @click="goHome">开始购物</div>
          </div>
        </div>
        <div v-if="cartInfo && cartInfo.goods_list && cartInfo.goods_list.goods && cartInfo.goods_list.goods.length > 1" class="miniPrice">
          <div class="price_box">
            <div class="price_name">总计:</div>
            <div class="price_num">￥{{totalPrice}}</div>
          </div>
          <div class="to_cart" @click="toCart">查看购物袋</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
import types from "@/store/types";
import utils from "@/utils/index";
import CartItemMini from '@/components/CartItemMini.vue';
import 'vuescroll/dist/vuescroll.css';
import VueScroll from 'vuescroll/dist/vuescroll-native';
export default {
  components: { CartItemMini, VueScroll},
  data() {
    return {
      vsOpts: {
        bar: {
          background: '#F6F6F6'
        }
      },
    };
  },
  computed: {
    cartInfo() {
      return this.$store.state.cartInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    totalPrice() {
      let price = 0
      let cartInfo = this.$store.state.cartInfo
      if(cartInfo && cartInfo.goods_list && cartInfo.goods_list.goods.length ){
        let goods = cartInfo.goods_list.goods
        goods.forEach(element => {
          if(element.main){
            element.main.forEach(item => {
              if(item.original_price && item.original_price != item.price) {
                price += parseFloat(item.original_price) 
              } else {
                price += parseFloat(item.price)
              }
            })
          }
        });
      }
      return price
    }
  },
  created() {},
  updated() {},
  methods: {
    closeLogin() {
      this.$store.commit("toggleMiniCar", false);
    },
    toCart() {
      this.$store.commit("toggleMiniCar", false);
      this.$router.push({ path: "/cart" });
    },
    // 删除
    onItemRemove(info) {
      this.$confirm({
        message: "确定要从购物车删除该商品吗？",
        showCancel: true
      }).then(() => {
        let { sku_key } = info.item;
        if (this.isLogin) {
          api[types.CART_DELETE]({ id: sku_key }).then(res => {
            if (res.code == 1) {
              res?.data?.goods_list && this.syncCartInfo();
            } else {
              this.$toast({ message: res.message, iconCls: "failure" });
            }
          });
        } else {
          utils.delCart(sku_key, () => {
            this.syncCartInfo();
          });
        }
      }).catch(() => {});
    },
    // 刷新购物车数据
    syncCartInfo(callback) {
      this.$store.dispatch(types.CART_GET, callback);
    },
    goHome() {
      this.closeLogin()
      this.$router.push({ path: "/" });
    }
  },
};
</script>

<style lang="scss" scoped>
.union-login {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.union-login__hits {
  font-size: 0.75rem;
}
.login-icon {
  margin-left: 0.5rem;
  font-size: 20px;
  line-height: 2.75rem;
  cursor: pointer;
}
.login-btn {
  .c-button-login {
    padding: 0.8125rem 1.25rem;
  }
}
.l-login-popin {
  position: fixed;
  right: -100%;
  top: 0;
  opacity: 0;
  background-color: #fff;
  height: 100%;
  z-index: 12;
  // max-width: 23.3125rem;
  width: 100%;
  transition-property: opacity, right;
  transition-duration: 1.5s, 1s;
  &.in {
    position: fixed;
    right: 0;
    opacity: 1;
    transition-property: opacity, right;
    transition-duration: 2s, 1.5s;
  }
  .l-login-popin-container {
    overflow-y: auto;
    height: 100%;
    padding: 2.3125rem 100px;
    padding-right: 80px;
    .l-login-popin__item-separator {
      padding-bottom: 1.125rem;
      width: 100%;
      .c-form__heading {
        font-weight: 700;
      }
    }
    .l-login-popin__heading {
      margin-top: 1.625rem;
    }
    h2 {
      margin-bottom: 2.5rem;
    }
    .l-login-popin__text {
      margin-bottom: 1.875rem;
    }
    .swiper-tab {
      display: flex;
      color: #5e5e5e;
      align-items: center;
      margin-bottom: 30px;
      .active {
        color: #282828;
        border-bottom: 2px solid #282828;
      }
      .swiper-tab-list {
        height: 100%;
        text-align: center;
        cursor: pointer;
        &:first-child {
          margin-right: 3rem;
        }
      }
    }
    .form-group {
      .sr-only {
        border: 0 !important;
        clip: rect(1px, 1px, 1px, 1px) !important;
        -webkit-clip-path: inset(50%) !important;
        clip-path: inset(50%) !important;
        height: 1px !important;
        overflow: hidden !important;
        padding: 0 !important;
        position: absolute !important;
        width: 1px !important;
        white-space: nowrap !important;
      }
      .c-input {
        &.is-invalid {
          border-color: #c53131;
        }
      }
      .invalid-feedback {
        position: absolute;
        // bottom: 86%;
        top: -0.575rem;
        left: 1.5625rem;
        background-color: #fff;
        padding: 0 0.5625rem;
        margin-bottom: 0;
        color: #c53131;
        font-size: 0.6875rem;
      }
      .custom-checkbox {
        display: flex;
        align-items: center;
        position: relative;
        margin-left: 1.375rem;
        .clickable {
          line-height: 1.5625rem;
          .iconfont {
            margin-right: 0.75rem;
            line-height: 1.5625rem;
          }
        }
      }
      .custom-control-input {
        position: absolute;
        opacity: 0;
        top: auto;
        overflow: hidden;
        clip: rect(1px, 1px, 1px, 1px);
        width: 0.0625rem;
        height: 0.0625rem;
        white-space: nowrap;
        display: block;
      }
      .custom-checkbox [type="checkbox"] {
        position: absolute;
        top: auto;
        overflow: hidden;
        clip: rect(1px, 1px, 1px, 1px);
        width: 0.0625rem;
        height: 0.0625rem;
        white-space: nowrap;
        display: block;
      }
      .reset-password {
        font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
        text-decoration: underline;
        line-height: 1.5625rem;
      }
    }
    .heading-h5 {
      font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
      font-weight: 400;
      font-style: normal;
      line-height: 1.66;
    }
    .c-form-explanation {
      font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
      font-size: 0.6875rem;
      font-weight: 300;
      padding: 0.875rem 1.25rem 0.8125rem;
    }
  }
  .float-center {
    display: block;
    margin-right: auto;
    margin-left: auto;
    .l-login-popin__close-button {
      display: inline-block;
    }
  }
  .c-input-error {
    border: 1px solid #df4c4c;
    background: #ffeaea;
  }
  .error-msg {
    color: #df4c4c;
    padding: 0.175rem 1rem 0;
  }
}
.miniPrice{

  .to_cart {
    width: 100%;
    height: 46px;
    background: #FFFFFF;
    border-radius: 23px;
    border: 1px solid #CFD0D1;
    line-height: 46px;
    text-align: center;
    cursor: pointer;
  }
  .price_box{
    display: flex;
    justify-content: space-between;
    padding-bottom: 30px;
    padding-top: 48px;
    .price_name{
      font-size: 14px;
      color: #282828;
    }
    .price_num{
      font-size: 14px;
      font-weight: 500;
      color: #000;
    }
  }
}
.cart_none{
  width: 100%;
  height: calc(100vh - 400px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .cart_none_msg{
    font-size: 24px;
    color: #282828;
    margin-bottom: 60px;
  }
  .go_home{
    width: 340px;
    height: 46px;
    border-radius: 23px;
    border: 1px solid #CFD0D1;
    font-size: 14px;
    font-weight: 500;
    color: #000;
    text-align: center;
    line-height: 46px;
    cursor: pointer;
  }
}
.cart-page {
  padding-right: 20px;
}
@media screen and (min-width: 48em) {
  .login-btn {
    .c-button-login {
      padding: 0.8125rem 1.875rem;
    }
  }
  .l-login-popin {
    max-width: 26.75rem;
    .l-login-popin-container {
      // padding: 2.3125rem 3.125rem;
      .c-button {
        font-size: 0.75rem;
        padding: 0.9375rem 1.875rem;
      }
      .c-button--rounded {
        padding: 0;
      }
      .c-button--primary {
        font-size: 0.75rem;
        padding: 0.9375rem 1.875rem;
      }
    }
  }
}
@media screen and (min-width: 64em) {
  .l-login-popin {
    max-width: 35.6875rem;
    min-width: 26.75rem;
  }
}
@media screen and (min-width: 75em) {
}
.m-cart__body{
  height: calc(100vh - 400px);
}
</style>